
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fAkdT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $b589e7b620e04fa8$var$runewords = [
    {
        name: "Ancient's Pledge",
        sockets: 3,
        itemType: [
            "Shields"
        ],
        runeOrder: [
            "Ral",
            "Ort",
            "Tal"
        ],
        effects: [
            "+50% Enhanced Defense",
            "Cold Resist +43%",
            "Fire Resist +48%",
            "Lightning Resist +48%",
            "Poison Resist +48%",
            "10% Damage Goes To Mana"
        ],
        level: 21,
        patch: "1.07"
    },
    {
        name: "Black",
        sockets: 3,
        itemType: [
            "Clubs",
            "Hammers",
            "Maces"
        ],
        runeOrder: [
            "Thul",
            "Io",
            "Nef"
        ],
        effects: [
            "+120% Enhanced Damage",
            "40% Chance Of Crushing Blow",
            "+200 To Attack Rating",
            "Adds 3-14 Cold Damage - Cold Duration 3 Seconds",
            "+10 To Vitality",
            "15% Increased Attack Speed",
            "Knockback",
            "Magic Damage Reduced By 2",
            "Level 4 Corpse Explosion (12 Charges)"
        ],
        level: 35,
        patch: "1.07"
    },
    {
        name: "Fury",
        sockets: 3,
        itemType: [
            "Melee Weapons"
        ],
        runeOrder: [
            "Jah",
            "Gul",
            "Eth"
        ],
        effects: [
            "+209% Enhanced Damage",
            "40% Increased Attack Speed",
            "Prevent Monster Heal",
            "66% Chance Of Open Wounds",
            "33% Deadly Strike",
            "Ignore Target's Defense",
            "-25% Target Defense",
            "20% Bonus To Attack Rating",
            "6% Life Stolen Per Hit",
            "+5 To Frenzy (Barbarian Only)"
        ],
        level: 65,
        patch: "1.07"
    },
    {
        name: "Holy Thunder",
        sockets: 4,
        itemType: [
            "Scepters"
        ],
        runeOrder: [
            "Eth",
            "Ral",
            "Ort",
            "Tal"
        ],
        effects: [
            "+60% Enhanced Damage",
            "-25% Target Defense",
            "Adds 5-30 Fire Damage",
            "Adds 21-110 Lightning Damage",
            "+75 Poison Damage Over 5 Seconds",
            "+10 To Maximum Damage",
            "Lightning Resistance +60%",
            "+5 To Maximum Lightning Resistance",
            "+3 To Holy Shock (Paladin Only)",
            "Level 7 Chain Lightning (60 Charges)"
        ],
        level: 21,
        patch: "1.07"
    },
    {
        name: "Honor",
        sockets: 5,
        itemType: [
            "Melee Weapons"
        ],
        runeOrder: [
            "Amn",
            "El",
            "Ith",
            "Tir",
            "Sol"
        ],
        effects: [
            "+160% Enhanced Damage",
            "+9 To Minimum Damage",
            "+9 To Maximum Damage",
            "25% Deadly Strike",
            "+250 To Attack Rating",
            "+1 to All Skills",
            "7% Life Stolen Per Hit",
            "Replenish Life +10",
            "+10 To Strength",
            "+1 To Light Radius",
            "+2 To Mana After Each Kill"
        ],
        level: 27,
        patch: "1.07"
    },
    {
        name: "King's Grace",
        sockets: 3,
        itemType: [
            "Swords",
            "Scepters"
        ],
        runeOrder: [
            "Amn",
            "Ral",
            "Thul"
        ],
        effects: [
            "+100% Enhanced Damage",
            "+100% Damage To Demons",
            "+50% Damage To Undead",
            "Adds 5-30 Fire Damage",
            "Adds 3-14 Cold Damage - 3 Second Duration",
            "+150 To Attack Rating",
            "+100 To Attack Rating Against Demons",
            "+100 To Attack Rating Against Undead",
            "7% Life Stolen Per Hit"
        ],
        level: 25,
        patch: "1.07"
    },
    {
        name: "Leaf",
        sockets: 2,
        itemType: [
            "Staves (Not Orbs)"
        ],
        runeOrder: [
            "Tir",
            "Ral"
        ],
        effects: [
            "Adds 5-30 Fire Damage",
            "+3 To Fire Skills",
            "+3 To Fire Bolt (Sorceress Only)",
            "+3 To Inferno (Sorceress Only)",
            "+3 To Warmth (Sorceress Only)",
            "+2 To Mana After Each Kill",
            "+ (2 Per Character Level) +2-198 To Defense (Based On Character Level)",
            "Cold Resist +33%"
        ],
        level: 19,
        patch: "1.07"
    },
    {
        name: "Lionheart",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Hel",
            "Lum",
            "Fal"
        ],
        effects: [
            "+20% Enhanced Damage",
            "Requirements -15%",
            "+25 To Strength",
            "+10 To Energy",
            "+20 To Vitality",
            "+15 To Dexterity",
            "+50 To Life",
            "All Resistances +30"
        ],
        level: 41,
        patch: "1.07"
    },
    {
        name: "Lore",
        sockets: 2,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Ort",
            "Sol"
        ],
        effects: [
            "+1 To All Skill Levels",
            "+10 To Energy",
            "+2 To Mana After Each Kill",
            "Lightning Resist +30%",
            "Damage Reduced By 7",
            "+2 To Light Radius"
        ],
        level: 27,
        patch: "1.07"
    },
    {
        name: "Malice",
        sockets: 3,
        itemType: [
            "Melee Weapons"
        ],
        runeOrder: [
            "Ith",
            "El",
            "Eth"
        ],
        effects: [
            "+33% Enhanced Damage",
            "+9 To Maximum Damage",
            "100% Chance Of Open Wounds",
            "-25% Target Defense",
            "-100 To Monster Defense Per Hit",
            "Prevent Monster Heal",
            "+50 To Attack Rating",
            "Drain Life -5"
        ],
        level: 15,
        patch: "1.07"
    },
    {
        name: "Melody",
        sockets: 3,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Shael",
            "Ko",
            "Nef"
        ],
        effects: [
            "+50% Enhanced Damage",
            "+300% Damage To Undead",
            "+3 To Bow and Crossbow Skills (Amazon Only)",
            "+3 To Critical Strike (Amazon Only)",
            "+3 To Dodge (Amazon Only)",
            "+3 To Slow Missiles (Amazon Only)",
            "20% Increased Attack Speed",
            "+10 To Dexterity",
            "Knockback"
        ],
        level: 39,
        patch: "1.07"
    },
    {
        name: "Memory",
        sockets: 4,
        itemType: [
            "Staves (Not Orbs)"
        ],
        runeOrder: [
            "Lum",
            "Io",
            "Sol",
            "Eth"
        ],
        effects: [
            "+3 to Sorceress Skill Levels",
            "33% Faster Cast Rate",
            "Increase Maximum Mana 20%",
            "+3 Energy Shield (Sorceress Only)",
            "+2 Static Field (Sorceress Only)",
            "+10 To Energy",
            "+10 To Vitality",
            "+9 To Minimum Damage",
            "-25% Target Defense",
            "Magic Damage Reduced By 7",
            "+50% Enhanced Defense"
        ],
        level: 37,
        patch: "1.07"
    },
    {
        name: "Nadir",
        sockets: 2,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Nef",
            "Tir"
        ],
        effects: [
            "+50% Enhanced Defense",
            "+10 Defense",
            "+30 Defense vs. Missile",
            "Level 13 Cloak of Shadows (9 Charges)",
            "+2 To Mana After Each Kill",
            "+5 To Strength",
            "-33% Extra Gold From Monsters",
            "-3 To Light Radius"
        ],
        level: 13,
        patch: "1.07"
    },
    {
        name: "Radiance",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Nef",
            "Sol",
            "Ith"
        ],
        effects: [
            "+75% Enhanced Defense",
            "+30 Defense Vs. Missile",
            "+10 To Energy",
            "+10 To Vitality",
            "15% Damage Goes To Mana",
            "Magic Damage Reduced By 3",
            "+33 To Mana",
            "Damage Reduced By 7",
            "+5 To Light Radius"
        ],
        level: 27,
        patch: "1.07"
    },
    {
        name: "Rhyme",
        sockets: 2,
        itemType: [
            "Shields"
        ],
        runeOrder: [
            "Shael",
            "Eth"
        ],
        effects: [
            "20% Increased Chance of Blocking",
            "40% Faster Block Rate",
            "All Resistances +25",
            "Regenerate Mana 15%",
            "Cannot Be Frozen",
            "50% Extra Gold From Monsters",
            "25% Better Chance Of Getting Magic Items"
        ],
        level: 29,
        patch: "1.07"
    },
    {
        name: "Silence",
        sockets: 6,
        itemType: [
            "Weapons"
        ],
        runeOrder: [
            "Dol",
            "Eld",
            "Hel",
            "Ist",
            "Tir",
            "Vex"
        ],
        effects: [
            "200% Enhanced Damage",
            "+75% Damage To Undead",
            "Requirements -20%",
            "20% Increased Attack Speed",
            "+50 To Attack Rating Against Undead",
            "+2 To All Skills",
            "All Resistances +75",
            "20% Faster Hit Recovery",
            "11% Mana Stolen Per Hit",
            "Hit Causes Monster To Flee 25%",
            "Hit Blinds Target +33",
            "+2 To Mana After Each Kill",
            "30% Better Chance Of Getting Magic Items"
        ],
        level: 55,
        patch: "1.07"
    },
    {
        name: "Smoke",
        sockets: 2,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Nef",
            "Lum"
        ],
        effects: [
            "+75% Enhanced Defense",
            "+280 Defense Vs. Missile",
            "All Resistances +50",
            "20% Faster Hit Recovery",
            "Level 6 Weaken (18 Charges)",
            "+10 To Energy",
            "-1 To Light Radius"
        ],
        level: 37,
        patch: "1.07"
    },
    {
        name: "Stealth",
        sockets: 2,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Tal",
            "Eth"
        ],
        effects: [
            "Magic Damage Reduced By 3",
            "+6 To Dexterity",
            "+15 To Maximum Stamina",
            "Poison Resist +30%",
            "Regenerate Mana 15%",
            "25% Faster Run/Walk",
            "25% Faster Cast Rate",
            "25% Faster Hit Recovery"
        ],
        level: 17,
        patch: "1.07"
    },
    {
        name: "Steel",
        sockets: 2,
        itemType: [
            "Swords",
            "Axes",
            "Maces"
        ],
        runeOrder: [
            "Tir",
            "El"
        ],
        effects: [
            "20% Enhanced Damage",
            "+3 To Minimum Damage",
            "+3 To Maximum Damage",
            "+50 To Attack Rating",
            "50% Chance Of Open Wounds",
            "25% Increased Attack Speed",
            "+2 To Mana After Each Kill",
            "+1 To Light Radius"
        ],
        level: 13,
        patch: "1.07"
    },
    {
        name: "Strength",
        sockets: 2,
        itemType: [
            "Melee Weapons"
        ],
        runeOrder: [
            "Amn",
            "Tir"
        ],
        effects: [
            "35% Enhanced Damage",
            "25% Chance Of Crushing Blow",
            "7% Life Stolen Per Hit",
            "+2 To Mana After Each Kill",
            "+20 To Strength",
            "+10 To Vitality"
        ],
        level: 25,
        patch: "1.07"
    },
    {
        name: "Venom",
        sockets: 3,
        itemType: [
            "Weapons"
        ],
        runeOrder: [
            "Tal",
            "Dol",
            "Mal"
        ],
        effects: [
            "Hit Causes Monster To Flee 25%",
            "Prevent Monster Heal",
            "Ignore Target's Defense",
            "7% Mana Stolen Per Hit",
            "Level 15 Poison Explosion (27 Charges)",
            "Level 13 Poison Nova (11 Charges)",
            "+273 Poison Damage Over 6 seconds"
        ],
        level: 49,
        patch: "1.07"
    },
    {
        name: "Wealth",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Lem",
            "Ko",
            "Tir"
        ],
        effects: [
            "300% Extra Gold From Monsters",
            "100% Better Chance Of Getting Magic Items",
            "+2 To Mana After Each Kill",
            "+10 To Dexterity"
        ],
        level: 43,
        patch: "1.07"
    },
    {
        name: "White",
        sockets: 2,
        itemType: [
            "Wand"
        ],
        runeOrder: [
            "Dol",
            "Io"
        ],
        effects: [
            "Hit Causes Monster To Flee 25%",
            "+10 To Vitality",
            "+3 To Poison And Bone Skills (Necromancer Only)",
            "+3 To Bone Armor (Necromancer Only)",
            "+2 To Bone Spear (Necromancer Only)",
            "+4 To Skeleton Mastery (Necromancer Only)",
            "Magic Damage Reduced By 4",
            "20% Faster Cast Rate",
            "+13 To Mana"
        ],
        level: 35,
        patch: "1.07"
    },
    {
        name: "Zephyr",
        sockets: 2,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Ort",
            "Eth"
        ],
        effects: [
            "+33% Enhanced Damage",
            "+66 To Attack Rating",
            "Adds 1-50 Lightning Damage",
            "-25% Target Defense",
            "+25 Defense",
            "25% Faster Run/Walk",
            "25% Increased Attack Speed",
            "7% Chance To Cast Level 1 Twister When Struck"
        ],
        level: 21,
        patch: "1.07"
    }
];
module.exports.default = $b589e7b620e04fa8$var$runewords;

});

parcelRegister("8hGyM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $6080eccc11b8d68e$var$runewords = [
    {
        name: "Beast",
        sockets: 5,
        itemType: [
            "Axes",
            "Scepters",
            "Hammers"
        ],
        runeOrder: [
            "Ber",
            "Tir",
            "Um",
            "Mal",
            "Lum"
        ],
        effects: [
            "Level 9 Fanaticism Aura When Equipped",
            "+40% Increased Attack Speed",
            "+240-270% Enhanced Damage (varies)",
            "20% Chance of Crushing Blow",
            "25% Chance of Open Wounds",
            "+3 To Werebear",
            "+3 To Lycanthropy",
            "Prevent Monster Heal",
            "+25-40 To Strength (varies)",
            "+10 To Energy",
            "+2 To Mana After Each Kill",
            "Level 13 Summon Grizzly (5 Charges)"
        ],
        level: 63,
        patch: "1.10"
    },
    {
        name: "Bramble",
        sockets: 4,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Ral",
            "Ohm",
            "Sur",
            "Eth"
        ],
        effects: [
            "Level 15-21 Thorns Aura When Equipped (varies)",
            "+50% Faster Hit Recovery",
            "+25-50% To Poison Skill Damage (varies)",
            "+300 Defense",
            "Increase Maximum Mana 5%",
            "Regenerate Mana 15%",
            "+5% To Maximum Cold Resist",
            "Fire Resist +30%",
            "Poison Resist +100%",
            "+13 Life After Each Kill",
            "Level 13 Spirit of Barbs (33 Charges)"
        ],
        level: 61,
        patch: "1.10"
    },
    {
        name: "Breath of the Dying",
        sockets: 6,
        itemType: [
            "Weapons"
        ],
        runeOrder: [
            "Vex",
            "Hel",
            "El",
            "Eld",
            "Zod",
            "Eth"
        ],
        effects: [
            "50% Chance To Cast Level 20 Poison Nova When You Kill An Enemy",
            "Indestructible",
            "+60% Increased Attack Speed",
            "+350-400% Enhanced Damage (varies)",
            "+200% Damage To Undead",
            "-25% Target Defense",
            "+50 To Attack Rating",
            "+50 To Attack Rating Against Undead",
            "7% Mana Stolen Per Hit",
            "12-15% Life Stolen Per Hit (varies)",
            "Prevent Monster Heal",
            "+30 To All Attributes",
            "+1 To Light Radius",
            "Requirements -20%"
        ],
        level: 69,
        patch: "1.10"
    },
    {
        name: "Call To Arms*",
        sockets: 5,
        itemType: [
            "Weapons"
        ],
        runeOrder: [
            "Amn",
            "Ral",
            "Mal",
            "Ist",
            "Ohm"
        ],
        effects: [
            "+1 To All Skills",
            "+40% Increased Attack Speed",
            "+250-290% Enhanced Damage (varies)",
            "Adds 5-30 Fire Damage",
            "7% Life Stolen Per Hit",
            "+2-6 To Battle Command (varies)*",
            "+1-6 To Battle Orders (varies)*",
            "+1-4 To Battle Cry (varies)*",
            "Prevent Monster Heal",
            "Replenish Life +12",
            "30% Better Chance of Getting Magic Items"
        ],
        level: 57,
        patch: "1.10"
    },
    {
        name: "Chains of Honor",
        sockets: 4,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Dol",
            "Um",
            "Ber",
            "Ist"
        ],
        effects: [
            "+2 To All Skills",
            "+200% Damage To Demons",
            "+100% Damage To Undead",
            "8% Life Stolen Per Hit",
            "+70% Enhanced Defense",
            "+20 To Strength",
            "Replenish Life +7",
            "All Resistances +65",
            "Damage Reduced By 8%",
            "25% Better Chance of Getting Magic Items"
        ],
        level: 63,
        patch: "1.10"
    },
    {
        name: "Chaos",
        sockets: 3,
        itemType: [
            "Claws"
        ],
        runeOrder: [
            "Fal",
            "Ohm",
            "Um"
        ],
        effects: [
            "9% Chance To Cast Level 11 Frozen Orb On Striking",
            "11% Chance To Cast Level 9 Charged Bolt On Striking",
            "+35% Increased Attack Speed",
            "+290-340% Enhanced Damage (varies)",
            "Adds 216-471 Magic Damage",
            "25% Chance of Open Wounds",
            "+1 To Whirlwind",
            "+10 To Strength",
            "+15 Life After Each Demon Kill"
        ],
        level: 57,
        patch: "1.10"
    },
    {
        name: "Crescent Moon",
        sockets: 3,
        itemType: [
            "Axes",
            "Swords",
            "Polearms"
        ],
        runeOrder: [
            "Shael",
            "Um",
            "Tir"
        ],
        effects: [
            "10% Chance To Cast Level 17 Chain Lightning On Striking",
            "7% Chance To Cast Level 13 Static Field On Striking",
            "+20% Increased Attack Speed",
            "+180-220% Enhanced Damage (varies)",
            "Ignore Target's Defense",
            "-35% To Enemy Lightning Resistance",
            "25% Chance of Open Wounds",
            "+9-11 Magic Absorb (varies)",
            "+2 To Mana After Each Kill",
            "Level 18 Summon Spirit Wolf (30 Charges)"
        ],
        level: 47,
        patch: "1.10"
    },
    {
        name: "Delirium*",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Lem",
            "Ist",
            "Io"
        ],
        effects: [
            "1% Chance To Cast Level 50 Delirium* (morph) When Struck",
            "6% Chance To Cast Level 14 Mind Blast When Struck",
            "14% Chance To Cast Level 13 Terror When Struck",
            "11% Chance To Cast Level 18 Confuse On Striking",
            "+2 To All Skills",
            "+261 Defense",
            "+10 To Vitality",
            "50% Extra Gold From Monsters",
            "25% Better Chance of Getting Magic Items",
            "Level 17 Attract (60 Charges)"
        ],
        level: 51,
        patch: "1.10"
    },
    {
        name: "Doom",
        sockets: 5,
        itemType: [
            "Axes",
            "Polearms",
            "Hammers"
        ],
        runeOrder: [
            "Hel",
            "Ohm",
            "Um",
            "Lo",
            "Cham"
        ],
        effects: [
            "5% Chance To Cast Level 18 Volcano On Striking",
            "Level 12 Holy Freeze Aura When Equipped",
            "+2 To All Skills",
            "+45% Increased Attack Speed",
            "+330-370% Enhanced Damage (varies)",
            "-(40-60)% To Enemy Cold Resistance (varies)",
            "20% Deadly Strike",
            "25% Chance of Open Wounds",
            "Prevent Monster Heal",
            "Freezes Target +3",
            "Requirements -20%"
        ],
        level: 67,
        patch: "1.10"
    },
    {
        name: "Duress",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Shael",
            "Um",
            "Thul"
        ],
        effects: [
            "+40% Faster Hit Recovery",
            "+10-20% Enhanced Damage (varies)",
            "Adds 37-133 Cold Damage 2 sec. Duration (Normal)",
            "15% Chance of Crushing Blow",
            "33% Chance of Open Wounds",
            "+150-200% Enhanced Defense (varies)",
            "-20% Slower Stamina Drain",
            "Cold Resist +45%",
            "Lightning Resist +15%",
            "Fire Resist +15%",
            "Poison Resist +15%"
        ],
        level: 47,
        patch: "1.10"
    },
    {
        name: "Enigma",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Jah",
            "Ith",
            "Ber"
        ],
        effects: [
            "+2 To All Skills",
            "+45% Faster Run/Walk",
            "+1 To Teleport",
            "+750-775 Defense (varies)",
            "+ (0.75 Per Character Level) +0-74 To Strength (Based On Character Level)",
            "Increase Maximum Life 5%",
            "Damage Reduced By 8%",
            "+14 Life After Each Kill",
            "15% Damage Taken Goes To Mana",
            "+ (1 Per Character Level) +1-99% Better Chance of Getting Magic Items (Based On Character Level)"
        ],
        level: 65,
        patch: "1.10"
    },
    {
        name: "Eternity",
        sockets: 5,
        itemType: [
            "Melee Weapons"
        ],
        runeOrder: [
            "Amn",
            "Ber",
            "Ist",
            "Sol",
            "Sur"
        ],
        effects: [
            "Indestructible",
            "+260-310% Enhanced Damage (varies)",
            "+9 To Minimum Damage",
            "7% Life Stolen Per Hit",
            "20% Chance of Crushing Blow",
            "Hit Blinds Target",
            "Slows Target By 33%",
            "Regenerate Mana 16%",
            "Replenish Life +16",
            "Cannot Be Frozen",
            "30% Better Chance Of Getting Magic Items",
            "Level 8 Revive (88 Charges)"
        ],
        level: 63,
        patch: "1.10"
    },
    {
        name: "Exile",
        sockets: 4,
        itemType: [
            "Paladin Shields (only)"
        ],
        runeOrder: [
            "Vex",
            "Ohm",
            "Ist",
            "Dol"
        ],
        effects: [
            "15% Chance To Cast Level 5 Life Tap On Striking",
            "Level 13-16 Defiance Aura When Equipped (varies)",
            "+2 To Offensive Auras (Paladin Only)",
            "+30% Faster Block Rate",
            "Freezes Target",
            "+220-260% Enhanced Defense (varies)",
            "Replenish Life +7",
            "+5% To Maximum Cold Resist",
            "+5% To Maximum Fire Resist",
            "25% Better Chance Of Getting Magic Items",
            "Repairs 1 Durability in 4 Seconds"
        ],
        level: 57,
        patch: "1.10"
    },
    {
        name: "Famine",
        sockets: 4,
        itemType: [
            "Axes",
            "Hammers"
        ],
        runeOrder: [
            "Fal",
            "Ohm",
            "Ort",
            "Jah"
        ],
        effects: [
            "+30% Increased Attack Speed",
            "+320-370% Enhanced Damage (varies)",
            "Ignore Target's Defense",
            "Adds 180-200 Magic Damage",
            "Adds 50-200 Fire Damage",
            "Adds 51-250 Lightning Damage",
            "Adds 50-200 Cold Damage",
            "12% Life Stolen Per Hit",
            "Prevent Monster Heal",
            "+10 To Strength"
        ],
        level: 65,
        patch: "1.10"
    },
    {
        name: "Gloom",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Fal",
            "Um",
            "Pul"
        ],
        effects: [
            "15% Chance To Cast Level 3 Dim Vision When Struck",
            "+10% Faster Hit Recovery",
            "+200-260% Enhanced Defense (varies)",
            "+10 To Strength",
            "All Resistances +45",
            "Half Freeze Duration",
            "5% Damage Taken Goes To Mana",
            "-3 To Light Radius"
        ],
        level: 47,
        patch: "1.10"
    },
    {
        name: "Hand of Justice*",
        sockets: 4,
        itemType: [
            "Weapons"
        ],
        runeOrder: [
            "Sur",
            "Cham",
            "Amn",
            "Lo"
        ],
        effects: [
            "100% Chance To Cast Level 36 Blaze When You Level-Up",
            "100% Chance To Cast Level 48 Meteor When You Die",
            "Level 16 Holy Fire Aura When Equipped",
            "+33% Increased Attack Speed",
            "+280-330% Enhanced Damage (varies)",
            "Ignore Target's Defense",
            "7% Life Stolen Per Hit",
            "-20% To Enemy Fire Resistance",
            "20% Deadly Strike",
            "Hit Blinds Target",
            "Freezes Target +3"
        ],
        level: 67,
        patch: "1.10"
    },
    {
        name: "Heart of the Oak",
        sockets: 4,
        itemType: [
            "Staves (Not Orbs)",
            "Maces"
        ],
        runeOrder: [
            "Ko",
            "Vex",
            "Pul",
            "Thul"
        ],
        effects: [
            "+3 To All Skills",
            "+40% Faster Cast Rate",
            "+75% Damage To Demons",
            "+100 To Attack Rating Against Demons",
            "Adds 3-14 Cold Damage, 3 sec. Duration (Normal)",
            "7% Mana Stolen Per Hit",
            "+10 To Dexterity",
            "Replenish Life +20",
            "Increase Maximum Mana 15%",
            "All Resistances +30-40 (varies)",
            "Level 4 Oak Sage (25 Charges)",
            "Level 14 Raven (60 Charges)"
        ],
        level: 55,
        patch: "1.10"
    },
    {
        name: "Kingslayer",
        sockets: 4,
        itemType: [
            "Swords",
            "Axes"
        ],
        runeOrder: [
            "Mal",
            "Um",
            "Gul",
            "Fal"
        ],
        effects: [
            "+30% Increased Attack Speed",
            "+230-270% Enhanced Damage (varies)",
            "-25% Target Defense",
            "20% Bonus To Attack Rating",
            "33% Chance of Crushing Blow",
            "50% Chance of Open Wounds",
            "+1 To Vengeance",
            "Prevent Monster Heal",
            "+10 To Strength",
            "40% Extra Gold From Monsters"
        ],
        level: 53,
        patch: "1.10"
    },
    {
        name: "Passion",
        sockets: 4,
        itemType: [
            "Weapons"
        ],
        runeOrder: [
            "Dol",
            "Ort",
            "Eld",
            "Lem"
        ],
        effects: [
            "+25% Increased Attack Speed",
            "+160-210% Enhanced Damage (varies)",
            "50-80% Bonus To Attack Rating (varies)",
            "+75% Damage To Undead",
            "+50 To Attack Rating Against Undead",
            "Adds 1-50 Lightning Damage",
            "+1 To Berserk",
            "+1 To Zeal",
            "Hit Blinds Target +10",
            "Hit Causes Monster To Flee 25%",
            "75% Extra Gold From Monsters",
            "Level 3 Heart of Wolverine (12 Charges)"
        ],
        level: 43,
        patch: "1.10"
    },
    {
        name: "Prudence",
        sockets: 2,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Mal",
            "Tir"
        ],
        effects: [
            "+25% Faster Hit Recovery",
            "+140-170% Enhanced Defense (varies)",
            "All Resistances +25-35 (varies)",
            "Damage Reduced by 3",
            "Magic Damage Reduced by 17",
            "+2 To Mana After Each Kill",
            "+1 To Light Radius",
            "Repairs Durability 1 In 4 Seconds"
        ],
        level: 49,
        patch: "1.10"
    },
    {
        name: "Sanctuary",
        sockets: 3,
        itemType: [
            "Shields"
        ],
        runeOrder: [
            "Ko",
            "Ko",
            "Mal"
        ],
        effects: [
            "+20% Faster Hit Recovery",
            "+20% Faster Block Rate",
            "20% Increased Chance of Blocking",
            "+130-160% Enhanced Defense (varies)",
            "+250 Defense vs. Missile",
            "+20 To Dexterity",
            "All Resistances +50-70 (varies)",
            "Magic Damage Reduced By 7",
            "Level 12 Slow Missiles (60 Charges)"
        ],
        level: 49,
        patch: "1.10"
    },
    {
        name: "Splendor",
        sockets: 2,
        itemType: [
            "Shields"
        ],
        runeOrder: [
            "Eth",
            "Lum"
        ],
        effects: [
            "+1 To All Skills",
            "+10% Faster Cast Rate",
            "+20% Faster Block Rate",
            "+60-100% Enhanced Defense (varies)",
            "+10 To Energy",
            "Regenerate Mana 15%",
            "50% Extra Gold From Monsters",
            "20% Better Chance of Getting Magic Items",
            "+3 To Light Radius"
        ],
        level: 37,
        patch: "1.10"
    },
    {
        name: "Stone",
        sockets: 4,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Shael",
            "Um",
            "Pul",
            "Lum"
        ],
        effects: [
            "+60% Faster Hit Recovery",
            "+250-290% Enhanced Defense (varies)",
            "+300 Defense Vs. Missile",
            "+16 To Strength",
            "+16 To Vitality",
            "+10 To Energy",
            "All Resistances +15",
            "Level 16 Molten Boulder (80 Charges)",
            "Level 16 Clay Golem (16 Charges)"
        ],
        level: 47,
        patch: "1.10"
    },
    {
        name: "Wind",
        sockets: 2,
        itemType: [
            "Melee Weapons"
        ],
        runeOrder: [
            "Sur",
            "El"
        ],
        effects: [
            "10% Chance To Cast Level 9 Tornado On Striking",
            "+20% Faster Run/Walk",
            "+40% Increased Attack Speed",
            "+15% Faster Hit Recovery",
            "+120-160% Enhanced Damage (varies)",
            "-50% Target Defense",
            "+50 To Attack Rating",
            "Hit Blinds Target",
            "+1 To Light Radius",
            "Level 13 Twister (127 Charges)"
        ],
        level: 61,
        patch: "1.10"
    }
];
module.exports.default = $6080eccc11b8d68e$var$runewords;

});

parcelRegister("knJTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $ed698ea4b7a57c27$var$runewords = [
    {
        name: "Brand",
        sockets: 4,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Jah",
            "Lo",
            "Mal",
            "Gul"
        ],
        effects: [
            "35% Chance To Cast Level 14 Amplify Damage When Struck",
            "100% Chance To Cast Level 18 Bone Spear On Striking",
            "+260-340% Enhanced Damage (varies)",
            "Ignore Target's Defense",
            "20% Bonus to Attack Rating",
            "+280-330% Damage To Demons (varies)",
            "20% Deadly Strike",
            "Prevent Monster Heal",
            "Knockback",
            "Fires Explosive Arrows or Bolts (15)"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Death",
        sockets: 5,
        itemType: [
            "Swords",
            "Axes"
        ],
        runeOrder: [
            "Hel",
            "El",
            "Vex",
            "Ort",
            "Gul"
        ],
        effects: [
            "100% Chance To Cast Level 44 Chain Lightning When You Die",
            "25% Chance To Cast Level 18 Glacial Spike On Attack",
            "Indestructible",
            "+300-385% Enhanced Damage (varies)",
            "20% Bonus To Attack Rating",
            "+50 To Attack Rating",
            "Adds 1-50 Lightning Damage",
            "7% Mana Stolen Per Hit",
            "50% Chance of Crushing Blow",
            "+(0.5 per Character Level) 0.5-49.5% Deadly Strike (Based on Character Level)",
            "+1 To Light Radius",
            "Level 22 Blood Golem (15 Charges)",
            "Requirements -20%"
        ],
        ladderOnly: true,
        level: 55,
        patch: "1.10"
    },
    {
        name: "Destruction",
        sockets: 5,
        itemType: [
            "Polearms",
            "Swords"
        ],
        runeOrder: [
            "Vex",
            "Lo",
            "Ber",
            "Jah",
            "Ko"
        ],
        effects: [
            "23% Chance To Cast Level 12 Volcano On Striking",
            "5% Chance To Cast Level 23 Molten Boulder On Striking",
            "100% Chance To Cast level 45 Meteor When You Die",
            "15% Chance To Cast Level 22 Nova On Attack",
            "+350% Enhanced Damage",
            "Ignore Target's Defense",
            "Adds 100-180 Magic Damage",
            "7% Mana Stolen Per Hit",
            "20% Chance Of Crushing Blow",
            "20% Deadly Strike",
            "Prevent Monster Heal",
            "+10 To Dexterity"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Dragon",
        sockets: 3,
        itemType: [
            "Body Armor",
            "Shields"
        ],
        runeOrder: [
            "Sur",
            "Lo",
            "Sol"
        ],
        effects: [
            "20% Chance to Cast Level 18 Venom When Struck",
            "12% Chance To Cast Level 15 Hydra On Striking",
            "Level 14 Holy Fire Aura When Equipped",
            "+360 Defense",
            "+230 Defense Vs. Missile",
            "+3-5 To All Attributes (varies)",
            "+0.375-37.125 To Strength (Based on Character Level)",
            "Increase Maximum Mana 5% (Armor Only)",
            "+50 To Mana (Shields Only)",
            "+5% To Maximum Lightning Resist",
            "Damage Reduced by 7"
        ],
        ladderOnly: true,
        level: 61,
        patch: "1.10"
    },
    {
        name: "Dream",
        sockets: 3,
        itemType: [
            "Helms",
            "Shields"
        ],
        runeOrder: [
            "Io",
            "Jah",
            "Pul"
        ],
        effects: [
            "10% Chance To Cast Level 15 Confuse When Struck",
            "Level 15 Holy Shock Aura When Equipped",
            "+20-30% Faster Hit Recovery (varies)",
            "+30% Enhanced Defense",
            "+150-220 Defense (varies)",
            "+10 To Vitality",
            "Increase Maximum Life 5% (Helms Only)",
            "+50 To Life (Shields Only)",
            "+0.625-61.875 To Mana (Based On Character Level)",
            "All Resistances +5-20 (varies)",
            "12-25% Better Chance of Getting Magic Items (varies)"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Edge",
        sockets: 3,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Tir",
            "Tal",
            "Amn"
        ],
        effects: [
            "Level 15 Thorns Aura When Equipped",
            "+35% Increased Attack Speed",
            "+320-380% Damage To Demons (varies)",
            "+280% Damage To Undead",
            "+75 Poison Damage Over 5 Seconds",
            "7% Life Stolen Per Hit",
            "Prevent Monster Heal",
            "+5-10 To All Attributes (varies)",
            "+2 To Mana After Each Kill",
            "Reduces All Vendor Prices 15%!!!*"
        ],
        ladderOnly: true,
        level: 25,
        patch: "1.10"
    },
    {
        name: "Faith",
        sockets: 4,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Ohm",
            "Jah",
            "Lem",
            "Eld"
        ],
        effects: [
            "Level 12-15 Fanaticism Aura When Equipped (varies)",
            "+1-2 To All Skills (varies)",
            "+330% Enhanced Damage",
            "Ignore Target's Defense",
            "300% Bonus To Attack Rating",
            "+75% Damage To Undead",
            "+50 To Attack Rating Against Undead",
            "+120 Fire Damage",
            "All Resistances +15",
            "10% Reanimate As: Returned",
            "75% Extra Gold From Monsters"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Fortitude",
        sockets: 4,
        itemType: [
            "Weapons",
            "Body Armor"
        ],
        runeOrder: [
            "El",
            "Sol",
            "Dol",
            "Lo"
        ],
        effects: [
            "Weapons",
            "20% Chance To Cast Level 15 Chilling Armor when Struck",
            "+25% Faster Cast Rate",
            "+300% Enhanced Damage",
            "+9 To Minimum Damage",
            "+50 To Attack Rating",
            "20% Deadly Strike",
            "Hit Causes Monster To Flee 25%",
            "+200% Enhanced Defense",
            "+X To Life (Based on Character Level)*",
            "All Resistances +25-30 (varies)",
            "12% Damage Taken Goes To Mana",
            "+1 To Light Radius",
            "",
            "Body Armor",
            "20% Chance To Cast Level 15 Chilling Armor when Struck",
            "+25% Faster Cast Rate",
            "+300% Enhanced Damage",
            "+200% Enhanced Defense",
            "+15 Defense",
            "+X To Life (Based on Character Level)*",
            "Replenish Life +7",
            "+5% To Maximum Lightning Resist",
            "All Resistances +25-30 (varies)",
            "Damage Reduced By 7",
            "12% Damage Taken Goes To Mana",
            "+1 To Light Radius"
        ],
        ladderOnly: true,
        level: 59,
        patch: "1.10"
    },
    {
        name: "Grief",
        sockets: 5,
        itemType: [
            "Swords",
            "Axes"
        ],
        runeOrder: [
            "Eth",
            "Tir",
            "Lo",
            "Mal",
            "Ral"
        ],
        effects: [
            "35% Chance To Cast Level 15 Venom On Striking",
            "+30-40% Increased Attack Speed (varies)",
            "Damage +340-400 (varies)",
            "Ignore Target's Defense",
            "-25% Target Defense",
            "+(1.875 per character level) 1.875-185.625% Damage To Demons (Based on Character Level)",
            "Adds 5-30 Fire Damage",
            "-20-25% To Enemy Poison Resistance (varies)",
            "20% Deadly Strike",
            "Prevent Monster Heal",
            "+2 To Mana After Each Kill",
            "+10-15 Life After Each Kill (varies)"
        ],
        ladderOnly: true,
        level: 59,
        patch: "1.10"
    },
    {
        name: "Harmony",
        sockets: 4,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Tir",
            "Ith",
            "Sol",
            "Ko"
        ],
        effects: [
            "Level 10 Vigor Aura When Equipped",
            "+200-275% Enhanced Damage (varies)",
            "+9 To Minimum Damage",
            "+9 To Maximum Damage",
            "Adds 55-160 Lightning Damage",
            "Adds 55-160 Fire Damage",
            "Adds 55-160 Cold Damage",
            "+2-6 To Valkyrie (varies)",
            "+10 To Dexterity",
            "Regenerate Mana 20%",
            "+2 To Mana After Each Kill",
            "+2 To Light Radius",
            "Level 20 Revive (25 Charges)"
        ],
        ladderOnly: true,
        level: 39,
        patch: "1.10"
    },
    {
        name: "Ice",
        sockets: 4,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Amn",
            "Shael",
            "Jah",
            "Lo"
        ],
        effects: [
            "100% Chance To Cast Level 40 Blizzard When You Level-up",
            "25% Chance To Cast Level 22 Frost Nova On Striking",
            "Level 18 Holy Freeze Aura When Equipped",
            "+20% Increased Attack Speed",
            "+140-210% Enhanced Damage (varies)",
            "Ignore Target's Defense",
            "+25-30% To Cold Skill Damage (varies)",
            "-20% To Enemy Cold Resistance",
            "7% Life Stolen Per Hit",
            "20% Deadly Strike",
            "3.125-309.375 Extra Gold From Monsters (Based on Character Level)"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Infinity",
        sockets: 4,
        itemType: [
            "Polearms"
        ],
        runeOrder: [
            "Ber",
            "Mal",
            "Ber",
            "Ist"
        ],
        effects: [
            "50% Chance To Cast Level 20 Chain Lightning When You Kill An Enemy",
            "Level 12 Conviction Aura When Equipped",
            "+35% Faster Run/Walk",
            "+255-325% Enhanced Damage (varies)",
            "-(45-55)% To Enemy Lightning Resistance (varies)",
            "40% Chance of Crushing Blow",
            "Prevent Monster Heal",
            "0.5-49.5 To Vitality (Based on Character Level)",
            "30% Better Chance of Getting Magic Items",
            "Level 21 Cyclone Armor (30 Charges)"
        ],
        ladderOnly: true,
        level: 63,
        patch: "1.10"
    },
    {
        name: "Insight",
        sockets: 4,
        itemType: [
            "Polearms",
            "Staves (Not Orbs)"
        ],
        runeOrder: [
            "Ral",
            "Tir",
            "Tal",
            "Sol"
        ],
        effects: [
            "Level 12-17 Meditation Aura When Equipped (varies)",
            "+35% Faster Cast Rate",
            "+200-260% Enhanced Damage (varies)",
            "+9 To Minimum Damage",
            "180-250% Bonus to Attack Rating (varies)",
            "Adds 5-30 Fire Damage",
            "+75 Poison Damage Over 5 Seconds",
            "+1-6 To Critical Strike (varies)",
            "+5 To All Attributes",
            "+2 To Mana After Each Kill",
            "23% Better Chance of Getting Magic Items"
        ],
        ladderOnly: true,
        level: 27,
        patch: "1.10"
    },
    {
        name: "Last Wish",
        sockets: 6,
        itemType: [
            "Swords",
            "Hammers",
            "Axes"
        ],
        runeOrder: [
            "Jah",
            "Mal",
            "Jah",
            "Sur",
            "Jah",
            "Ber"
        ],
        effects: [
            "6% Chance To Cast Level 11 Fade When Struck",
            "10% Chance To Cast Level 18 Life Tap On Striking",
            "20% Chance To Cast Level 20 Charged Bolt On Attack",
            "Level 17 Might Aura When Equipped",
            "+330-375% Enhanced Damage (varies)",
            "Ignore Target's Defense",
            "60-70% Chance of Crushing Blow (varies)",
            "Prevent Monster Heal",
            "Hit Blinds Target",
            "+(0.5 per character level) 0.5-49.5% Chance of Getting Magic Items (Based on Character Level)"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Lawbringer",
        sockets: 3,
        itemType: [
            "Swords",
            "Hammers",
            "Scepters"
        ],
        runeOrder: [
            "Amn",
            "Lem",
            "Ko"
        ],
        effects: [
            "20% Chance To Cast Level 15 Decrepify On Striking",
            "Level 16-18 Sanctuary Aura When Equipped (varies)",
            "-50% Target Defense",
            "Adds 150-210 Fire Damage",
            "Adds 130-180 Cold Damage",
            "7% Life Stolen Per Hit",
            "Slain Monsters Rest In Peace",
            "+200-250 Defense Vs. Missile (varies)",
            "+10 To Dexterity",
            "75% Extra Gold From Monsters"
        ],
        ladderOnly: true,
        level: 43,
        patch: "1.10"
    },
    {
        name: "Oath",
        sockets: 4,
        itemType: [
            "Swords",
            "Axes",
            "Maces"
        ],
        runeOrder: [
            "Shael",
            "Pul",
            "Mal",
            "Lum"
        ],
        effects: [
            "30% Chance To Cast Level 20 Bone Spirit On Striking",
            "Indestructible",
            "+50% Increased Attack Speed",
            "+210-340% Enhanced Damage (varies)",
            "+75% Damage To Demons",
            "+100 To Attack Rating Against Demons",
            "Prevent Monster Heal",
            "+10 To Energy",
            "+10-15 Magic Absorb (varies)",
            "Level 16 Heart Of Wolverine (20 Charges)",
            "Level 17 Iron Golem (14 Charges)"
        ],
        ladderOnly: true,
        level: 49,
        patch: "1.10"
    },
    {
        name: "Obedience",
        sockets: 5,
        itemType: [
            "Polearms"
        ],
        runeOrder: [
            "Hel",
            "Ko",
            "Thul",
            "Eth",
            "Fal"
        ],
        effects: [
            "30% Chance To Cast Level 21 Enchant When You Kill An Enemy",
            "40% Faster Hit Recovery",
            "+370% Enhanced Damage",
            "-25% Target Defense",
            "Adds 3-14 Cold Damage 3 Second Duration (Normal)",
            "-25% To Enemy Fire Resistance",
            "40% Chance of Crushing Blow",
            "+200-300 Defense (varies)",
            "+10 To Strength",
            "+10 To Dexterity",
            "All Resistances +20-30 (varies)",
            "Requirements -20%"
        ],
        ladderOnly: true,
        level: 41,
        patch: "1.10"
    },
    {
        name: "Phoenix",
        sockets: 4,
        itemType: [
            "Weapons",
            "Shields"
        ],
        runeOrder: [
            "Vex",
            "Vex",
            "Lo",
            "Jah"
        ],
        effects: [
            "Weapons",
            "100% Chance To Cast level 40 Blaze When You Level-up",
            "40% Chance To Cast Level 22 Firestorm On Striking",
            "Level 10-15 Redemption Aura When Equipped (varies)",
            "+350-400% Enhanced Damage (varies)",
            "Ignores Target's Defense",
            "14% Mana Stolen Per Hit",
            "-28% To Enemy Fire Resistance",
            "20% Deadly Strike",
            "+350-400 Defense Vs. Missile (varies)",
            "+15-21 Fire Absorb (varies)",
            "",
            "Shields",
            "100% Chance To Cast level 40 Blaze When You Level-up",
            "40% Chance To Cast Level 22 Firestorm On Striking",
            "Level 10-15 Redemption Aura When Equipped (varies)",
            "+350-400 Defense Vs. Missile (varies)",
            "+350-400% Enhanced Damage (varies)",
            "-28% To Enemy Fire Resistance",
            "+50 To Life",
            "+5% To Maximum Lightning Resist",
            "+10% To Maximum Fire Resist",
            "+15-21 Fire Absorb (varies)"
        ],
        ladderOnly: true,
        level: 65,
        patch: "1.10"
    },
    {
        name: "Pride",
        sockets: 4,
        itemType: [
            "Polearms"
        ],
        runeOrder: [
            "Cham",
            "Sur",
            "Io",
            "Lo"
        ],
        effects: [
            "25% Chance To Cast Level 17 Fire Wall When Struck",
            "Level 16-20 Concentration Aura When Equipped (varies)",
            "260-300% Bonus To Attack Rating (varies)",
            "+1-99% Damage To Demons (Based on Character Level)",
            "Adds 50-280 Lightning Damage",
            "20% Deadly Strike",
            "Hit Blinds Target",
            "Freezes Target +3",
            "+10 To Vitality",
            "Replenish Life +8",
            "1.875-185.625% Extra Gold From Monsters (Based on Character Level)"
        ],
        ladderOnly: true,
        level: 67,
        patch: "1.10"
    },
    {
        name: "Rift",
        sockets: 4,
        itemType: [
            "Polearms",
            "Scepters"
        ],
        runeOrder: [
            "Hel",
            "Ko",
            "Lem",
            "Gul"
        ],
        effects: [
            "20% Chance To Cast Level 16 Tornado On Striking",
            "16% Chance To Cast Level 21 Frozen Orb On Attack",
            "20% Bonus To Attack Rating",
            "Adds 160-250 Magic Damage",
            "Adds 60-180 Fire Damage",
            "+5-10 To All Stats (varies)",
            "+10 To Dexterity",
            "38% Damage Taken Goes To Mana",
            "75% Extra Gold From Monsters",
            "Level 15 Iron Maiden (40 Charges)",
            "Requirements -20%"
        ],
        ladderOnly: true,
        level: 53,
        patch: "1.10"
    },
    {
        name: "Spirit",
        sockets: 4,
        itemType: [
            "Swords",
            "Shields"
        ],
        runeOrder: [
            "Tal",
            "Thul",
            "Ort",
            "Amn"
        ],
        effects: [
            "Weapons",
            "+2 To All Skills",
            "+25-35% Faster Cast Rate (varies)",
            "+55% Faster Hit Recovery",
            "Adds 1-50 Lightning Damage",
            "Adds 3-14 Cold Damage 3 Second Duration (Normal)",
            "+75 Poison Damage Over 5 Seconds",
            "7% Life Stolen Per Hit",
            "+250 Defense Vs. Missile",
            "+22 To Vitality",
            "+89-112 To Mana (varies)",
            "+3-8 Magic Absorb (varies)",
            "",
            "Shields",
            "+2 To All Skills",
            "+25-35% Faster Cast Rate (varies)",
            "+55% Faster Hit Recovery",
            "+250 Defense Vs. Missile",
            "+22 To Vitality",
            "+89-112 To Mana (varies)",
            "Cold Resist +35%",
            "Lightning Resist +35%",
            "Poison Resist +35%",
            "+3-8 Magic Absorb (varies)",
            "Attacker Takes Damage of 14"
        ],
        ladderOnly: true,
        level: 25,
        patch: "1.10"
    },
    {
        name: "Voice of Reason",
        sockets: 4,
        itemType: [
            "Swords",
            "Maces"
        ],
        runeOrder: [
            "Lem",
            "Ko",
            "El",
            "Eld"
        ],
        effects: [
            "15% Chance To Cast Level 13 Frozen Orb On Striking",
            "18% Chance To Cast Level 20 Ice Blast On Striking",
            "+50 To Attack Rating",
            "+220-350% Damage To Demons",
            "+355-375% Damage To Undead (varies)",
            "+50 To Attack Rating Against Undead",
            "Adds 100-220 Cold Damage",
            "-24% To Enemy Cold Resistance",
            "+10 To Dexterity",
            "Cannot Be Frozen",
            "75% Extra Gold From Monsters",
            "+1 To Light Radius"
        ],
        ladderOnly: true,
        level: 43,
        patch: "1.10"
    },
    {
        name: "Wrath",
        sockets: 4,
        itemType: [
            "Missile Weapons"
        ],
        runeOrder: [
            "Pul",
            "Lum",
            "Ber",
            "Mal"
        ],
        effects: [
            "30% Chance To Cast Level 1 Decrepify On Striking",
            "5% Chance To Cast Level 10 Life Tap On Striking",
            "+375% Damage To Demons",
            "+100 To Attack Rating Against Demons",
            "+250-300% Damage To Undead (varies)",
            "Adds 85-120 Magic Damage",
            "Adds 41-240 Lightning Damage",
            "20% Chance of Crushing Blow",
            "Prevent Monster Heal",
            "+10 To Energy",
            "Cannot Be Frozen"
        ],
        ladderOnly: true,
        level: 63,
        patch: "1.10"
    }
];
module.exports.default = $ed698ea4b7a57c27$var$runewords;

});

parcelRegister("2Mdye", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $205a936f2c20d64f$var$runewords = [
    {
        name: "Bone (Necromancer)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Sol",
            "Um",
            "Um"
        ],
        effects: [
            "15% Chance To Cast level 10 Bone Armor When Struck",
            "15% Chance To Cast level 10 Bone Spear On Striking",
            "+2 To Necromancer Skill Levels",
            "+100-150 To Mana (varies)",
            "All Resistances +30",
            "Damage Reduced By 7"
        ],
        level: 47,
        patch: "1.11"
    },
    {
        name: "Enlightenment (Sorceress)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Pul",
            "Ral",
            "Sol"
        ],
        effects: [
            "5% Chance To Cast Level 15 Blaze When Struck",
            "5% Chance To Cast level 15 Fire Ball On Striking",
            "+2 To Sorceress Skill Levels",
            "+1 To Warmth",
            "+30% Enhanced Defense",
            "Fire Resist +30%",
            "Damage Reduced By 7"
        ],
        level: 45,
        patch: "1.11"
    },
    {
        name: "Myth (Barbarian)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Hel",
            "Amn",
            "Nef"
        ],
        effects: [
            "3% Chance To Cast Level 1 Howl When Struck",
            "10% Chance To Cast Level 1 Taunt On Striking",
            "+2 To Barbarian Skill Levels",
            "+30 Defense Vs. Missile",
            "Replenish Life +10",
            "Attacker Takes Damage of 14",
            "Requirements -15%"
        ],
        level: 25,
        patch: "1.11"
    },
    {
        name: "Peace (Amazon)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Shael",
            "Thul",
            "Amn"
        ],
        effects: [
            "4% Chance To Cast Level 5 Slow Missiles When Struck",
            "2% Chance To Cast level 15 Valkyrie On Striking",
            "+2 To Amazon Skill Levels",
            "+20% Faster Hit Recovery",
            "+2 To Critical Strike",
            "Cold Resist +30%",
            "Attacker Takes Damage of 14"
        ],
        level: 29,
        patch: "1.11"
    },
    {
        name: "Principle (Paladin)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Ral",
            "Gul",
            "Eld"
        ],
        effects: [
            "100% Chance To Cast Level 5 Holy Bolt On Striking",
            "+2 To Paladin Skill Levels",
            "+50% Damage to Undead",
            "+100-150 To Life (varies)",
            "15% Slower Stamina Drain",
            "+5% To Maximum Poison Resist",
            "Fire Resist +30%"
        ],
        level: 53,
        patch: "1.11"
    },
    {
        name: "Rain (Druid)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Ort",
            "Mal",
            "Ith"
        ],
        effects: [
            "5% Chance To Cast Level 15 Cyclone Armor When Struck",
            "5% Chance To Cast Level 15 Twister On Striking",
            "+2 To Druid Skills",
            "+100-150 To Mana (varies)",
            "Lightning Resist +30%",
            "Magic Damage Reduced By 7",
            "15% Damage Taken Goes to Mana"
        ],
        level: 49,
        patch: "1.11"
    },
    {
        name: "Treachery (Assassin)",
        sockets: 3,
        itemType: [
            "Body Armor"
        ],
        runeOrder: [
            "Shael",
            "Thul",
            "Lem"
        ],
        effects: [
            "5% Chance To Cast Level 15 Fade When Struck",
            "25% Chance To Cast level 15 Venom On Striking",
            "+2 To Assassin Skills",
            "+45% Increased Attack Speed",
            "+20% Faster Hit Recovery",
            "Cold Resist +30%",
            "50% Extra Gold From Monsters"
        ],
        level: 43,
        patch: "1.11"
    }
];
module.exports.default = $205a936f2c20d64f$var$runewords;

});

parcelRegister("5T9RN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4499be25a63a4ce7$var$runewords = [
    {
        name: "Plague",
        sockets: 3,
        itemType: [
            "Swords"
        ],
        runeOrder: [
            "Cham",
            "Shael",
            "Um"
        ],
        effects: [
            "20% Chance to cast level 12 Lower Resist when struck",
            "25% Chance to cast level 15 Poison Nova on striking",
            "Level 13-17 Cleansing Aura When Equipped (varies)",
            "+1-2 All Skills",
            "+20% Increased Attack Speed",
            "+220-320% Enhanced Damage (varies)",
            "-23% To Enemy Poison Resistance",
            "0.3% (0-29.7) Deadly Strike (Based on Character Level)",
            "+25% Chance of Open Wounds",
            "Freezes Target +3"
        ],
        level: 67,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    },
    {
        name: "Pattern",
        sockets: 3,
        itemType: [
            "Claws"
        ],
        runeOrder: [
            "Tal",
            "Ort",
            "Thul"
        ],
        effects: [
            "+30% Faster Block Rate",
            "+40-80% Enhanced Damage (varies)",
            "10% Bonus to Attack Rating",
            "Adds 17-62 Fire Damage",
            "Adds 1-50 Lightning Damage",
            "Adds 3-14 Cold Damage",
            "+75 Poison Damage Over 5 Seconds",
            "+6 to Strength",
            "+6 to Dexterity",
            "All Resistances +15"
        ],
        level: 23,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    },
    {
        name: "Unbending Will",
        sockets: 6,
        itemType: [
            "Swords"
        ],
        runeOrder: [
            "Fal",
            "Io",
            "Ith",
            "Eld",
            "El",
            "Hel"
        ],
        effects: [
            "18% Chance to cast Level 18 Taunt on striking",
            "+3 To Combat Skills (Barbarian Only)",
            "+20-30% Increased Attack Speed (varies)",
            "+300-350% Enhanced Damage (varies)",
            "+9 To Maximum Damage",
            "+50 To Attack Rating",
            "+75% Damage to Undead",
            "+50 Attack Rating Against Undead",
            "8-10% Life Stolen Per Hit (varies)",
            "Prevent Monster Heal",
            "+10 To Strength",
            "+10 To Vitality",
            "Damage Reduced By 8",
            "+1 Light Radius",
            "Requirements -20%"
        ],
        level: 41,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    },
    {
        name: "Wisdom",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Pul",
            "Ith",
            "Eld"
        ],
        effects: [
            "+33% Piercing Attack",
            "+15-25% Bonus to Attack Rating (varies)",
            "4-8% Mana Stolen Per Hit (varies)",
            "+30% Enhanced Defense",
            "+10 Energy",
            "15% Slower Stamina Drain",
            "Cannot Be Frozen",
            "+5 Mana After Each Kill",
            "15% Damage Taken Goes to Mana"
        ],
        level: 45,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    },
    {
        name: "Obsession",
        sockets: 6,
        itemType: [
            "Staves (Not Orbs)"
        ],
        runeOrder: [
            "Zod",
            "Ist",
            "Lem",
            "Lum",
            "Io",
            "Nef"
        ],
        effects: [
            "Indestructible",
            "24% Chance to cast level 10 Weaken when struck",
            "+4 To All Skills",
            "+65% Faster Cast Rate",
            "+60% Faster Hit Recovery",
            "Knockback",
            "+10 To Vitality",
            "+10 To Energy",
            "Increase Maximum Life 15-25% (varies)",
            "Regenerate Mana 15-30% (varies)",
            "All Resistances +60-70 (varies)",
            "75% Extra Gold from Monsters",
            "30% Better Chance of Getting Magic Items"
        ],
        level: 69,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    },
    {
        name: "Flickering Flame",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Nef",
            "Pul",
            "Vex"
        ],
        effects: [
            "Level 4-8 Resist Fire Aura When Equipped (varies)",
            "+3 To Fire Skills",
            "-10-15% to Enemy Fire Resistance (varies)",
            "+30% Enhanced Defense",
            "+30 Defense Vs. Missile",
            "+50-75 To Mana (varies)",
            "Half Freeze Duration",
            "+5% To Maximum Fire Resist",
            "Poison Length Reduced by 50%"
        ],
        level: 55,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    },
    {
        name: "Mist",
        sockets: 5,
        itemType: [
            "Bows",
            "Crossbows",
            "Missile Weapons"
        ],
        runeOrder: [
            "Cham",
            "Shael",
            "Gul",
            "Thul",
            "Ith"
        ],
        effects: [
            "Level 8-12 Concentration Aura When Equipped (varies)",
            "+3 To All Skills",
            "20% Increased Attack Speed",
            "+100% Piercing Attack",
            "+325-375% Enhanced Damage (varies)",
            "+9 To Maximum Damage",
            "20% Bonus to Attack Rating",
            "Adds 3-14 Cold Damage",
            "Freeze Target +3",
            "+24 Vitality",
            "All Resistances +40"
        ],
        level: 67,
        diablo2ResurrectedOnly: true,
        patch: "2.4"
    }
];
module.exports.default = $4499be25a63a4ce7$var$runewords;

});

parcelRegister("fg9BV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $b1bfce2326f8bd08$var$runewords = [
    {
        name: "Bulwark",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Shael",
            "Io",
            "Sol"
        ],
        effects: [
            "+20% Faster Hit Recovery",
            "+4-6% Life stolen per hit",
            "+75-100% Enhanced Defense",
            "+10 to Vitality",
            "Increase Maximum Life 5%",
            "Replenish Life +30",
            "Damage Reduced by 7",
            "Physical Damage Received Reduced by 10-15%"
        ],
        level: 35,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Cure",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Shael",
            "Io",
            "Tal"
        ],
        effects: [
            "Level 1 Cleansing Aura when Equipped",
            "+20% Faster Hit Recovery",
            "+75-100% Enhanced Defense",
            "+10 to Vitality",
            "Increase Maximum Life 5%",
            "Poison Resist +40-60%",
            "Poison Length Reduced by 50%"
        ],
        level: 35,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Ground",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Shael",
            "Io",
            "Ort"
        ],
        effects: [
            "+20% Faster Hit Recovery",
            "+75-100% Enhanced Defense",
            "+10 to Vitality",
            "Increase Maximum Life 5%",
            "Lightning Resist +40-60%",
            "Lightning Absorb +10-15%"
        ],
        level: 35,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Hearth",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Shael",
            "Io",
            "Thul"
        ],
        effects: [
            "+20% Faster Hit Recovery",
            "+75-100% Enhanced Defense",
            "+10 to Vitality",
            "Increase Maximum Life 5%",
            "Cold Resist +40-60%",
            "Cold Absorb +10-15%",
            "Cannot be Frozen"
        ],
        level: 35,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Temper",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Shael",
            "Io",
            "Ral"
        ],
        effects: [
            "+20% Faster Hit Recovery",
            "+75-100% Enhanced Defense",
            "+10 to Vitality",
            "Increase Maximum Life 5%",
            "Fire Resist +40-60%",
            "Fire Absorb +10-15%"
        ],
        level: 35,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Hustle",
        sockets: 3,
        itemType: [
            "Body Armor",
            "Weapons"
        ],
        runeOrder: [
            "Shael",
            "Ko",
            "Eld"
        ],
        effects: [
            "Armor",
            "+65% Faster Run/Walk",
            "+40% Increased Attack Speed",
            "+20% Faster Hit Recovery",
            "+6 to Evade",
            "+10 to Dexterity",
            "50% Slower Stamina Drain",
            "+All Resistances +10",
            "",
            "Weapons",
            "5% Chance to cast level 1 9 Burst of Speed on striking",
            "Level 1 Fanaticism Aura",
            "+30% Increased Attack Speed",
            "+180-200% Enhanced Damage",
            "+75% Damage to Undead",
            "+50 to Attack Rating against Undead",
            "+10 to Dexterity"
        ],
        level: 39,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Mosaic",
        sockets: 3,
        itemType: [
            "Claws"
        ],
        runeOrder: [
            "Mal",
            "Gul",
            "Amn"
        ],
        effects: [
            "+50% chance for finishing moves to not consume charges",
            "When a finisher is executed this way, it now refreshes the expiration timer of the stack",
            "+2 to Martial Arts (Assassin only)",
            "+20% Increased Attack Speed",
            "+200-250% Enhanced Damage",
            "+20% Bonus to Attack Rating",
            "7% Life Steal",
            "+8-15% to Cold Skill Damage",
            "+8-15% to Lightning Skill Damage",
            "+8-15% to Fire Skill Damage",
            "Prevent Monster Heal"
        ],
        level: 53,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    },
    {
        name: "Metamorphosis",
        sockets: 3,
        itemType: [
            "Helms"
        ],
        runeOrder: [
            "Io",
            "Cham",
            "Fal"
        ],
        effects: [
            "Werewolf strikes grant Mark for 180 seconds",
            "Mark of the Wolf: +30% Bonus to Attack Rating",
            "Mark of the Wolf: Increase Maximum Life 40%",
            "Werebear strikes grant Mark for 180 seconds",
            "Mark of the Bear: +25% Attack Speed",
            "Mark of the Bear: Physical Damage Received Reduced by 20%",
            "+5 to Shape Shifting Skills (Druid only)",
            "+25% Chance of Crushing Blow",
            "+50-80% Enhanced Defense",
            "+10 to Strength",
            "+10 to Vitality",
            "All Resistances +10",
            "Cannot be Frozen"
        ],
        level: 67,
        diablo2ResurrectedOnly: true,
        patch: "2.6"
    }
];
module.exports.default = $b1bfce2326f8bd08$var$runewords;

});

class $9a5c636476ca87ea$export$2e2bcd8739ae039 {
    constructor(attachToElement){
        this.container = attachToElement;
    }
    // Helper to create each runeword Item
    runewordItem({ name: name, level: level, sockets: sockets, itemType: itemType, runeOrder: runeOrder, effects: effects }) {
        const item = document.createElement("li");
        const itemHeader = document.createElement("div");
        itemHeader.classList.add("header-block");
        const toggleHidden = (event)=>{
            event.currentTarget.nextSibling.hidden = !event.currentTarget.nextSibling.hidden;
        };
        itemHeader.onclick = toggleHidden;
        item.appendChild(itemHeader);
        // Title Container
        const titleDiv = document.createElement("div");
        titleDiv.classList.add("flex-apart");
        itemHeader.appendChild(titleDiv);
        // Title Row
        const titleLeft = document.createElement("h3");
        titleLeft.innerText = name;
        titleDiv.appendChild(titleLeft);
        const titleRight = document.createElement("span");
        titleRight.innerText = `Level ${level}`;
        titleDiv.appendChild(titleRight);
        // Subtitle Row
        const subtitleDiv = document.createElement("div");
        subtitleDiv.classList.add("flex-apart");
        itemHeader.appendChild(subtitleDiv);
        const subtitleLeft = document.createElement("span");
        subtitleLeft.innerText = `(${sockets}) ${runeOrder}`;
        subtitleDiv.appendChild(subtitleLeft);
        const subtitleRight = document.createElement("span");
        subtitleRight.innerText = itemType;
        subtitleDiv.appendChild(subtitleRight);
        // List of Effects
        const effectList = document.createElement("ul");
        effectList.classList.add("runeword-effects");
        effectList.hidden = true;
        effects.forEach((effect)=>{
            const effectItem = document.createElement("li");
            effectItem.innerText = effect;
            effectList.appendChild(effectItem);
        });
        item.appendChild(effectList);
        return item;
    }
    // Simple helper to create the whole list
    runewordList(runewords) {
        const list = document.createElement("ul");
        runewords.forEach((word)=>{
            list.appendChild(this.runewordItem(word));
        });
        return list;
    }
    createActionButton(text, onClick, active) {
        const actionButton = document.createElement("button");
        actionButton.innerText = text;
        actionButton.onclick = onClick;
        // Make active if the filter is active
        if (active) actionButton.classList.add("active");
        return actionButton;
    }
    createActionToggle(text, onClick, active) {
        const toggleHtml = `
    <div class="switch-container">
      <label class="switch">
        <input type="checkbox" ${active ? "checked" : ""} />
        <span class="slider"></span>
      </label>
      <span class="switch-text">${text}</span>
    </div>`;
        const template = document.createElement("template");
        template.innerHTML = toggleHtml;
        const actionToggle = template.content.firstElementChild;
        actionToggle.querySelector("input").onclick = onClick;
        return actionToggle;
    }
    // Runeword action bar
    /**
   *
   * @param {Array} actions [{action: function, actionValue: string, text: string}]
   * @param {string} headerText creates a heaver for the actions
   */ runewordActions(actions, headerText = "", useToggles = false) {
        // Build a header for the filters
        const actionHeader = document.createElement("h4");
        actionHeader.innerText = headerText;
        const actionSection = document.createElement("div");
        actionSection.appendChild(actionHeader);
        const actionDiv = document.createElement("div");
        actionDiv.classList.add("runeword-actions");
        actionSection.appendChild(actionDiv);
        let buttons = [];
        if (useToggles) // Toggle switches (checkboxes)
        buttons = actions.map(({ action: action, actionValue: actionValue, active: active, text: text })=>this.createActionToggle(text, ()=>action(actionValue), active));
        else // Buttons
        buttons = actions.map(({ action: action, actionValue: actionValue, active: active, text: text })=>this.createActionButton(text, ()=>action(actionValue), active));
        buttons.forEach((button)=>{
            actionDiv.appendChild(button);
        });
        return actionSection;
    }
    clearUI(container) {
        while(container.firstChild)container.removeChild(container.firstChild);
    }
    showAllEffects(show) {
        const allEffects = document.querySelectorAll(".runeword-effects");
        allEffects.forEach((effect)=>{
            effect.hidden = !show;
        });
    }
    render(data, sortAction, filterActions) {
        const { runewords: runewords, itemTypes: itemTypes, filters: filters, sortBy: sortBy } = data;
        const { itemType: chosenItemType, sockets: chosenNumberOfSockets } = filters;
        const { filterBySocket: filterBySocket, filterByItemType: filterByItemType } = filterActions;
        this.clearUI(this.container);
        // Build sortable actions
        this.container.appendChild(this.runewordActions([
            {
                action: sortAction,
                actionValue: "name",
                active: sortBy === "name",
                text: "Name"
            },
            {
                action: sortAction,
                actionValue: "level",
                active: sortBy === "level",
                text: "Min Level Required"
            }
        ], "Sort By..."));
        // Build Socket Filter Actions
        const socketNumbers = [
            2,
            3,
            4,
            5,
            6
        ];
        const socketActions = socketNumbers.map((numberOption)=>({
                action: filterBySocket,
                actionValue: numberOption,
                active: chosenNumberOfSockets.includes(numberOption),
                text: numberOption
            }));
        const useToggles = true;
        this.container.appendChild(this.runewordActions(socketActions, "Number of Sockets", useToggles));
        // Build Item Type Filter Actions
        const typeActions = itemTypes.map((itemTypeOption)=>({
                action: filterByItemType,
                actionValue: itemTypeOption,
                active: chosenItemType.includes(itemTypeOption),
                text: itemTypeOption
            }));
        this.container.appendChild(this.runewordActions(typeActions, "Item Types", useToggles));
        // Button to show all and hide all
        this.container.appendChild(this.runewordActions([
            {
                action: this.showAllEffects,
                actionValue: true,
                active: false,
                text: "Expand All"
            },
            {
                action: this.showAllEffects,
                actionValue: false,
                active: false,
                text: "Collapse All"
            }
        ]));
        // Show the list
        this.container.appendChild(this.runewordList(runewords));
    }
}


var $74087218bd6aeccb$exports = {};
"use strict";
Object.defineProperty($74087218bd6aeccb$exports, "__esModule", {
    value: true
});
$74087218bd6aeccb$exports.filterWords = $74087218bd6aeccb$exports.sortWords = $74087218bd6aeccb$exports.getAllWords = void 0;
var $65577f037e8b6267$exports = {};
"use strict";
var $65577f037e8b6267$var$__importDefault = $65577f037e8b6267$exports && $65577f037e8b6267$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($65577f037e8b6267$exports, "__esModule", {
    value: true
});
$65577f037e8b6267$exports.getAllWords = void 0;

const $65577f037e8b6267$var$_1_07_1 = $65577f037e8b6267$var$__importDefault((parcelRequire("fAkdT")));

const $65577f037e8b6267$var$_1_10_1 = $65577f037e8b6267$var$__importDefault((parcelRequire("8hGyM")));

const $65577f037e8b6267$var$_1_10_ladder_1 = $65577f037e8b6267$var$__importDefault((parcelRequire("knJTC")));

const $65577f037e8b6267$var$_1_11_1 = $65577f037e8b6267$var$__importDefault((parcelRequire("2Mdye")));

const $65577f037e8b6267$var$d2r_2_4_1 = $65577f037e8b6267$var$__importDefault((parcelRequire("5T9RN")));

const $65577f037e8b6267$var$d2r_2_6_1 = $65577f037e8b6267$var$__importDefault((parcelRequire("fg9BV")));
function $65577f037e8b6267$var$getAllWords() {
    const allWords = [
        ...$65577f037e8b6267$var$_1_07_1.default,
        ...$65577f037e8b6267$var$_1_10_1.default,
        ...$65577f037e8b6267$var$_1_10_ladder_1.default,
        ...$65577f037e8b6267$var$_1_11_1.default,
        ...$65577f037e8b6267$var$d2r_2_4_1.default,
        ...$65577f037e8b6267$var$d2r_2_6_1.default
    ];
    return allWords;
}
$65577f037e8b6267$exports.getAllWords = $65577f037e8b6267$var$getAllWords;


Object.defineProperty($74087218bd6aeccb$exports, "getAllWords", {
    enumerable: true,
    get: function() {
        return $65577f037e8b6267$exports.getAllWords;
    }
});
var $8b9e49fdaf6dec9a$exports = {};
"use strict";
Object.defineProperty($8b9e49fdaf6dec9a$exports, "__esModule", {
    value: true
});
$8b9e49fdaf6dec9a$exports.sortWords = $8b9e49fdaf6dec9a$exports.SORT_OPTIONS = void 0;
$8b9e49fdaf6dec9a$exports.SORT_OPTIONS = {
    LEVEL: "level",
    NAME: "name"
};
function $8b9e49fdaf6dec9a$var$sortWords(words, sortBy) {
    return words.sort((wordA, wordB)=>{
        if (wordA[sortBy] < wordB[sortBy]) return -1;
        else if (wordA[sortBy] > wordB[sortBy]) return 1;
        return 0;
    });
}
$8b9e49fdaf6dec9a$exports.sortWords = $8b9e49fdaf6dec9a$var$sortWords;


Object.defineProperty($74087218bd6aeccb$exports, "sortWords", {
    enumerable: true,
    get: function() {
        return $8b9e49fdaf6dec9a$exports.sortWords;
    }
});
var $b19b6f735ba56190$exports = {};
"use strict";
Object.defineProperty($b19b6f735ba56190$exports, "__esModule", {
    value: true
});
$b19b6f735ba56190$exports.filterWords = void 0;
function $b19b6f735ba56190$var$arraysIntersect(array1, array2) {
    return array1.some((element)=>array2.includes(element));
}
function $b19b6f735ba56190$var$filterWords(words, filters) {
    // Iterate through every word and apply each filter
    // by keeping what has been passed in with filters
    return words.filter((word)=>{
        // Apply WordFilters.itemType
        let itemTypeFound = true;
        if (filters.itemType.length > 0 && !$b19b6f735ba56190$var$arraysIntersect(word.itemType, filters.itemType)) itemTypeFound = false;
        // Apply WordFilters.sockets
        let socketsFound = filters.sockets.length === 0 || filters.sockets.includes(word.sockets);
        let gamesFound = false;
        if (filters.games.length === 0 || word.diablo2ResurrectedOnly && filters.games.includes("diablo2Resurrected") || !word.diablo2ResurrectedOnly && filters.games.includes("diablo2")) gamesFound = true;
        return socketsFound && itemTypeFound && gamesFound;
    });
}
$b19b6f735ba56190$exports.filterWords = $b19b6f735ba56190$var$filterWords;


Object.defineProperty($74087218bd6aeccb$exports, "filterWords", {
    enumerable: true,
    get: function() {
        return $b19b6f735ba56190$exports.filterWords;
    }
});


class $8b8db41c66412ab0$export$2e2bcd8739ae039 {
    /**
   *
   * @param {RunewordsUI} runewordsUI
   * @param {Array} runewords
   */ constructor(runewordsUI, data){
        const { runewords: runewords, itemTypes: itemTypes } = data;
        this.allRunewords = [
            ...runewords
        ];
        this.ui = runewordsUI;
        this.state = {
            runewords: [
                ...runewords
            ],
            itemTypes: itemTypes,
            filters: {
                itemType: [],
                sockets: [],
                games: []
            },
            sortBy: "name"
        };
        this.renderUI();
    }
    get runewords() {
        return this.state.runewords || [];
    }
    get filters() {
        return this.state.filters || {};
    }
    get itemTypes() {
        return this.state.itemTypes || [];
    }
    renderUI() {
        this.ui.render(this.state, this.sortWordsBy.bind(this), {
            maxLevelFilter: this.maxLevelFilter.bind(this),
            filterBySocket: this.filterBySocket.bind(this),
            filterByItemType: this.filterByItemType.bind(this)
        });
    }
    setState(newState) {
        this.state = {
            ...this.state,
            ...newState
        };
        this.renderUI();
    }
    sortWordsBy(propertyName) {
        const currentRunewords = this.runewords.slice();
        this.setState({
            runewords: (0, $74087218bd6aeccb$exports.sortWords)(currentRunewords, propertyName),
            sortBy: propertyName
        });
    }
    // Logic for applying filters (determine new runewords state)
    applyFilters(runewords, filters) {
        return (0, $74087218bd6aeccb$exports.filterWords)(runewords, filters);
    }
    maxLevelFilter(maxCharacterLevel) {
        this.setFilters({
            ...this.filters,
            maxLevel: maxCharacterLevel
        });
    }
    filterBySocket(numberOfSockets) {
        // Toggle the selected value in the filter
        const index = this.filters.sockets.indexOf(numberOfSockets);
        if (index !== -1) this.filters.sockets.splice(index, 1);
        else this.filters.sockets.push(numberOfSockets);
        this.setFilters({
            ...this.filters
        });
    }
    filterByItemType(itemType) {
        // Toggle the selected value in the filter
        const index = this.filters.itemType.indexOf(itemType);
        if (index !== -1) this.filters.itemType.splice(index, 1);
        else this.filters.itemType.push(itemType);
        this.setFilters({
            ...this.filters
        });
    }
    // When we set the filter we want to apply them too
    // 1. Create the Filter values
    // 2. Apply filter to get new runeword data
    // 3. Set State (filters and runewords)
    // 4. Trigger UI
    setFilters(filters) {
        const newRunewords = this.applyFilters(this.allRunewords, filters);
        this.setState({
            runewords: (0, $74087218bd6aeccb$exports.sortWords)(newRunewords, this.state.sortBy),
            filters: filters
        });
    }
}


function $7c004e007ff5df04$export$2e2bcd8739ae039(runewords) {
    const itemTypes = {};
    runewords.forEach((word)=>{
        word.itemType.forEach((type)=>{
            if (typeof itemTypes[type] === "undefined") itemTypes[type] = 0;
            itemTypes[type]++;
        });
    });
    const itemTypesArray = Object.keys(itemTypes).sort();
    return itemTypesArray;
}




const $c5415cf4959c5e4c$var$runewordsContainer = document.getElementById("runewords");
const $c5415cf4959c5e4c$var$runewordsUI = new (0, $9a5c636476ca87ea$export$2e2bcd8739ae039)($c5415cf4959c5e4c$var$runewordsContainer);
const $c5415cf4959c5e4c$var$words = (0, $74087218bd6aeccb$exports.getAllWords)();
const $c5415cf4959c5e4c$var$runewordsController = new (0, $8b8db41c66412ab0$export$2e2bcd8739ae039)($c5415cf4959c5e4c$var$runewordsUI, {
    runewords: $c5415cf4959c5e4c$var$words,
    itemTypes: (0, $7c004e007ff5df04$export$2e2bcd8739ae039)($c5415cf4959c5e4c$var$words)
});
// Sort by minLevel by default
$c5415cf4959c5e4c$var$runewordsController.sortWordsBy("level");


//# sourceMappingURL=diablo-2-runewords.027df9a7.js.map
